module.exports = __webpack_public_path__ + "img/8.b781e282.jpg";